// extracted by mini-css-extract-plugin
export default {"container":"AddNewTuneUser_container__f7hUr","block":"AddNewTuneUser_block__ssrdw"};